import { LAST_PATH_STORAGE_KEY } from './constants';

/**
 * Get the last visited venue path from localStorage
 */
export const getLastPathCookie = (): string | null => {
  try {
    return localStorage.getItem(LAST_PATH_STORAGE_KEY);
  } catch (error: unknown) {
    console.error('Error getting path from localStorage:', error);
    return null;
  }
};
